import PersonPlusIcon from './PersonPlusIcon';

export default PersonPlusIcon;
